// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Pipe({
  name: 'ngbTime',
  standalone: false,
})
export class NgbTimeFormatPipe implements PipeTransform {
  transform(date: string | Date): NgbTimeStruct {
    if (date instanceof Date) {
      date = moment(date).format();
    }

    const time = date?.split('T')[1] ?? '';
    const [hours, minutes] = time.split(':');
    return {
      hour: parseInt(hours, 10),
      minute: parseInt(minutes, 10),
      second: 0,
    };
  }
}
